const it = {
  pleaseEnterUsername: "Inserisci un nome utente",
  cannotFriendYourself: "Non puoi inviare una richiesta di amicizia a te stesso.",
  friendRequestSent: "Richiesta di amicizia inviata!",
  failedToSendRequest: "Impossibile inviare la richiesta",
  linkCopied: "Link copiato negli appunti!",
  backToInvites: "Torna agli inviti",
  sendFriendRequestByUsername: "Invia una richiesta di amicizia tramite nome utente",
  enterUsername: "Inserisci un nome utente",
  send: "Invia",
  yourInviteQrCode: "Il tuo codice QR di invito",
  inviteLink: "Link di invito",
  scanQrOrUseLink: "Scansiona questo codice QR o utilizza questo link per inviare una richiesta di amicizia",
  copyInviteLink: "Copia link di invito",
  goToItem: "Vai all'elemento",
  verificationEmailSent: "Email di verifica inviata! Controlla la tua posta in arrivo.",
  verificationEmailFailed: "Impossibile inviare l'email di verifica. Riprova.",
  verifyYourEmail: "Verifica la tua email",
  verifyEmailInstructions: "Verifica il tuo indirizzo email per accedere al tuo account. Controlla la tua casella di posta per il link di verifica.",
  sending: "Invio in corso...",
  resendVerificationEmail: "Invia nuovamente l'email di verifica",
  login: "Accedi",
  register: "Registrati",
  home: "Home",
  calendar: "Calendario",
  friends: "Amici",
  profile: "Profilo",
  logout: "Disconnetti",
  loading: "Caricamento...",
  language: "Lingua",
  calendarSelectPlaceSuggestion: "Seleziona un luogo dai suggerimenti in modo che vengano associate le coordinate.",
  calendarSelectDateAndTime: "Seleziona data e ora.",
  calendarPositiveDuration: "Inserisci una durata positiva.",
  calendarFutureDateRequired: "La data e l'ora dell'evento devono essere nel futuro.",
  calendarCreateEventFailed: "Impossibile creare l'evento. Riprova.",
  cancel: "Annulla",
  createNewEvent: "Crea nuovo evento",
  week: "Settimana",
  month: "Mese",
  eventTitle: "Titolo",
  date: "Data",
  time: "Ora",
  duration: "Durata",
  endsAt: "Termina alle",
  place: "Luogo",
  searchForPlace: "Cerca un luogo",
  placeSearchTip: "Suggerimento: inizia a digitare e seleziona un risultato per allegare le coordinate.",
  description: "Descrizione",
  createEvent: "Crea evento",
  today: "Oggi",
  previousMonth: "Mese precedente",
  nextMonth: "Mese successivo",
  previous: "Precedente",
  next: "Successivo",
  mondayShort: "Lun",
  tuesdayShort: "Mar",
  wednesdayShort: "Mer",
  thursdayShort: "Gio",
  fridayShort: "Ven",
  saturdayShort: "Sab",
  sundayShort: "Dom",
  more: "altro",
  mustRespondWillBeforeReposting: "Devi rispondere \"Parteciperò\" prima di ripubblicare",
  event: "Evento",
  backToCalendar: "Torna al calendario",
  addToGoogleCalendar: "Aggiungi a Google Calendar",
  when: "Quando",
  where: "Dove",
  openLocationInGoogleMaps: "Apri posizione in Google Maps",
  hosts: "Organizzatori",
  yourResponse: "La tua risposta",
  currentResponse: "Risposta attuale",
  response_will: "Parteciperò",
  response_might: "Potrei partecipare",
  response_wont: "Non parteciperò",
  willRunIntoYou: "Passerò da lì",
  mightDropBy: "Potrei fare un salto",
  wontCome: "Non verrò",
  repostToMyFriends: "Condividi con i miei amici",
  responses: "Risposte",
  willAttend: "Parteciperà",
  reposted: "Condiviso",
  mightAttend: "Potrebbe partecipare",
  cancelEvent: "Annulla evento",
  cancellationEmailNoticeBefore: "Le persone che hanno confermato la propria partecipazione",
  cancellationEmailNoticeAfter: "riceveranno un'email di notifica dell'annullamento.",
  optionalCancellationMessage: "Messaggio facoltativo per i partecipanti (massimo 1000 caratteri)",
  confirmCancelEvent: "Conferma annullamento evento",
  clear: "Cancella",
  confirmCancellation: "Conferma annullamento",
  confirmCancellationMessage: "Sei sicuro di voler annullare questo evento? I partecipanti confermati verranno avvisati e l'evento sarà rimosso.",
  eventCancelledNotified: "Evento annullato. Notificati",
  attendees: "partecipanti",
  failedToCancelEvent: "Impossibile annullare l'evento",
  back: "Indietro",
  cancelled: "Annullato",
  ok: "OK",
  forgotPassword: "Password dimenticata",
  email: "Email",
  passwordResetLinkSent: "Se l'account esiste, è stato inviato un link per reimpostare la password.",
  passwordResetRequestFailed: "Richiesta di reimpostazione password non riuscita.",
  sendResetLink: "Invia link di reimpostazione",
  addFriend: "Aggiungi amico",
  incomingRequests: "Richieste ricevute",
  accept: "Accetta",
  deny: "Rifiuta",
  myFriends: "I miei amici",
  noFriendsYet: "Non hai ancora amici. Inizia ad aggiungerne!",
  seeProfile: "Visualizza profilo",
  noEventsToRespondTo: "Nessun evento a cui rispondere",
  allCaughtUp: "Sei aggiornato. Torna più tardi per vedere nuovi eventi dei tuoi amici.",
  events: "Eventi",
  unknown: "Sconosciuto",
  noDescriptionProvided: "Nessuna descrizione fornita.",
  will: "Sì",
  maybe: "Forse",
  wont: "No",
  userNotFound: "Utente non trovato",
  friendRequestSentSuccessfully: "Richiesta di amicizia inviata con successo!",
  friendInvitation: "Invito di amicizia",
  sendFriendRequest: "Invia richiesta di amicizia",
  loginToSendFriendRequest: "Accedi per inviare una richiesta di amicizia",
  chooseLanguage: "Scegli lingua",
  invalidCredentials: "Credenziali non valide. Riprova.",
  username: "Nome utente",
  password: "Password",
  forgotPasswordQuestion: "Hai dimenticato la password?",
  dontHaveAccount: "Non hai un account?",
  registerHere: "Registrati qui",
  invalidProfilePhotoType: "Tipo di file non valido. Carica un'immagine JPEG, PNG, GIF o WebP.",
  invalidFileExtension: "Estensione file non valida",
  allowedExtensions: "Consentite",
  fileTooLarge: "File troppo grande",
  maximumFileSize: "Massimo",
  profilePhotoRemoved: "Foto profilo rimossa.",
  failedToRemoveProfilePhoto: "Impossibile rimuovere la foto profilo",
  profileUpdatedSuccessfully: "Profilo aggiornato con successo!",
  failedToUpdateProfile: "Impossibile aggiornare il profilo",
  privateEmailExplanation: "Solo tu puoi vedere la tua email per evitare messaggi indesiderati al di fuori della piattaforma",
  yourEmailIsPrivate: "La tua email è privata.",
  profilePhoto: "Foto profilo",
  removePhoto: "Rimuovi foto",
  firstName: "Nome",
  lastName: "Cognome",
  tellPeopleAboutYourself: "Parla di te",
  whereToContactMe: "Come contattarmi",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Salva",
  notSet: "Non impostato",
  editProfile: "Modifica profilo",
  imageToCrop: "Immagine da ritagliare",
  zoom: "Zoom",
  usePhoto: "Usa foto",
  name: "Nome",
  whereToContact: "Contatto",
  removeFriendship: "Rimuovi amicizia",
  confirmRemoveFriend: "Conferma rimozione amico",
  confirmRemoveFriendBefore: "Sei sicuro di voler rimuovere",
  confirmRemoveFriendAfter: "dalla tua lista amici?",
  friendRemoved: "Amico rimosso.",
  failedToRemoveFriend: "Impossibile rimuovere l'amico.",
  confirmRemove: "Conferma rimozione",
  error: "Errore",
  removed: "Rimosso",
  passwordsDoNotMatch: "Le password non coincidono",
  registrationFailed: "Registrazione non riuscita. Riprova.",
  confirmPassword: "Conferma password",
  alreadyHaveAccount: "Hai già un account?",
  loginHere: "Accedi qui",
  passwordResetSuccessfully: "Password reimpostata con successo.",
  failedToResetPassword: "Impossibile reimpostare la password.",
  resetPassword: "Reimposta password",
  newPassword: "Nuova password",
  confirmNewPassword: "Conferma nuova password",
  setNewPassword: "Imposta nuova password",
  emailVerifiedSuccessfully: "Email verificata con successo!",
  emailVerificationFailed: "Verifica non riuscita. Il link potrebbe essere non valido o scaduto.",
  verifying: "Verifica in corso...",
  verified: "Verificato!",
  redirectingToHome: "Reindirizzamento alla home...",
  verificationFailed: "Verifica non riuscita",
  goToHome: "Vai alla home",
  about: "Informazioni",
  aboutConceptTitle: "Concetto",
  aboutCreatorIntroduction: "Ciao, sono Crypt0, un arrampicatore e il creatore di Run Into Me.",
  aboutCreatorStory: "Ho creato questo sito perché sono molto socievole e, tra una parete e l'altra, parlo sempre con altri arrampicatori. Mi sono ritrovato con troppi numeri e a dedicare troppo tempo libero all'organizzazione delle sessioni.",
  aboutPlanningProblem: "Ero stanco di pianificare e scrivere a ogni amico separatamente; volevo comunicare a tutti insieme quando e dove avrei arrampicato, senza inviti formali.",
  aboutDeveloperSolution: "Poi mi sono ricordato di essere uno sviluppatore e di poter creare da solo una soluzione.",
  aboutWelcome: "Benvenuto su Run Into Me, un sito per far sapere agli amici quando svolgi un'attività a cui possono unirsi senza pressioni.",
  aboutCallToAction: "La prossima volta che pianifichi un'attività fattibile da solo ma più divertente insieme, pubblicala qui per i tuoi amici!",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "Nella schermata Calendario puoi anche creare un nuovo evento.",
  aboutEventColorsIntroduction: "I colori indicano lo stato della partecipazione:",
  aboutColorGold: "Oro",
  aboutColorGoldDescription: "Organizzi questo evento.",
  aboutColorGreen: "Verde",
  aboutColorGreenDescription: "Partecipi a questo evento.",
  aboutColorOrange: "Arancione",
  aboutColorOrangeDescription: "Hai risposto «forse».",
  aboutColorBlue: "Blu",
  aboutColorBlueDescription: "Non hai ancora risposto.",
  aboutColorGray: "Grigio",
  aboutColorGrayDescription: "Hai rifiutato l’invito.",
  aboutCalendarEventDetails: "Fai clic su un evento per vedere i dettagli e rispondere.",
  aboutFriendPageTitle: "Pagina amici",
  aboutFriendPageDescription: "Per aggiungere un amico, inserisci il suo nome utente o inviagli il link di invito / codice QR.",
  aboutHomePageTitle: "Pagina iniziale",
  aboutHomePageDescription: "Scorri i prossimi eventi degli amici e indica se parteciperai.",
  aboutRepostScreenTitle: "Schermata di ripubblicazione",
  aboutGoogleCalendarDescription: "Usa questo pulsante per aggiungere l’evento a Google Calendar.",
  aboutRepostDescription: "Dopo aver confermato la partecipazione, puoi ripubblicare l’evento per i tuoi amici.",
};

export default it;